import * as React from "react";
const IconInformationCircle = ({ fill = "#212A3D", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "1em"}
    height="1em"
    fill={fill}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m9-4a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1m-1 4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default IconInformationCircle;
